var map = {
	"./21DaywithPython.webp": 9068,
	"./AliMoeinianProfilePicture.webp": 4614,
	"./Cyrus.webp": 1113,
	"./EMMET Plugin.webp": 2934,
	"./GitGithub.webp": 8696,
	"./Licenses.webp": 6873,
	"./Neumeronyms.webp": 4691,
	"./Pyscript.webp": 2061,
	"./complex-networks-gnn.webp": 2561,
	"./country-city-language-dw.webp": 9110,
	"./customer-segmentation-clustering.webp": 2423,
	"./diabetes-risk-ml.webp": 418,
	"./digital-health-assistant.webp": 9873,
	"./ed-patient-registry-ai.webp": 5169,
	"./erpnext-deployment-demo.webp": 2863,
	"./google-play-analytics.webp": 9954,
	"./healthagent.webp": 6420,
	"./industrial-iot-lakehouse.webp": 4971,
	"./insideforge.webp": 256,
	"./nyc-taxi-delta-lakehouse.webp": 3643,
	"./persian-rag-chatbot.webp": 349,
	"./personal-portfolio-llm.webp": 8474,
	"./smart-librarian.webp": 9071,
	"./spark-hadoop-twitter-trends.webp": 6757,
	"./trend-identification-text-mining.webp": 2294,
	"./web3-future-of-money.webp": 2857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5961;